import { CircularProgress } from "@mui/material";
import { GeneralFetch } from "Api/generalFetch/generalFetch";
import PageLayout from "components/LayoutContainers/PageLayout";
import { useCrossTabSync } from "hooks/common/broadCast";
import { useParams } from "hooks/common/useQueryParams";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { token } from "schemas";

export default function RedirectComponent() {
    const navigate = new useNavigate()
    const { fetchData } = GeneralFetch()
    const { urlParamiters } = useParams()
    const { id } = urlParamiters()
    const [tokenData, setToken] = useRecoilState(token)

    useCrossTabSync("token", (val) => { setToken(val) })

    useEffect(() => {
        if (tokenData)
            void fetchData({}, 'checkToken', 'post', 'checkToken').then((resp) => {
                if (resp?.valid && id != null) {
                    navigate('/registos?id=' + id)
                } else {
                    navigate('/sign-in?id=' + id)
                }
            })
        else navigate('/sign-in?id=' + id)
    }, [tokenData])

    return (
        <PageLayout>
            <div style={{ width: "100vw", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }} >
                <CircularProgress style={{ color: "#7EBDC3" }} />
            </div>
        </PageLayout>
    )
}
